import { render } from "./MultisidebarContent.vue?vue&type=template&id=7f65a87b&ts=true"
import script from "./MultisidebarContent.vue?vue&type=script&lang=ts"
export * from "./MultisidebarContent.vue?vue&type=script&lang=ts"

import "./MultisidebarContent.vue?vue&type=style&index=0&id=7f65a87b&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__